import {TWebsiteContentID} from "../Types/TWebsiteContentID";
import { ShowBluescreen } from "../Logic/ShowBluescreen";
import { GAME_FONT_ITALIC } from "../Constants/Constants";

export const SEARCH_HOMEPAGE = "http://www.drugle.com";

export enum SpecialPageTypes {
    Symptoms = "symptoms",
    Exams = "exams",
    Treatments = "treatments",
    Diagnoses = "diagnoses",

    SearchPage = "search"
}

export const WebsiteContents: Record<TWebsiteContentID, { contents: string, onVisit?: () => void }> = {
    "about:blank": {
        contents: ""
    },
    "http://help.doctos.org/cases": {
        contents: `
<b>+================+
|     Case Help     |
+================+</b>

<b>How do I take new cases?</b>
Click the Start button in the bottom-left of your screen, and click "Request new case". Choose a case from here, and it'll be added to your inbox.

<b>What are some good first steps with a case?</b>
If the patient presents with physical symptoms (aches, pains, swellings, etc.) then a Physical Examination is a good start. Similarly, patients presenting with neurological or psychological issues should be examined with an Interview.

<b>I can't solve this case!</b>
Don't worry! If you're truly stumped, you can give it your best guess and if you're wrong, you'll still get most of the XP and the case will be passed to another doctor!
(if DoctOS has corrupted/bugged the case, then you can abandon it at the bottom of the case email)


`,

    },
    "http://help.doctos.org/xp": {
        contents: `
<b>+================+
|      XP Help      |
+================+</b>

<b>How do I gain the most XP?</b>
You gain the most XP from treating symptoms, so revealing as many symptoms and treating them is the best way. Doing this fast, and making the correct diagnosis, will maximise XP. However, making incorrect treatments will impact your score negatively.

<b>Can I lose XP?</b>
No! Even if you make many mistakes, you'll always gain some experience! (keep this in mind in real life too! <3) 


`,

    },
    "http://help.doctos.org/diagnosing": {
        contents: `
<b>+================+
|  Diagnosis Help   |
+================+</b>

<b>I know the diagnosis but the treatment takes a week, what do I do?</b>
If the treatment is already ordered/prescribed, then you can make the diagnosis and the XP will be the same (unless of course, you prescribed the wrong treatment!)
`,

    },
    "http://help.doctos.org": {
        contents: `
<b>+================+
|  DoctOS Help page  |
+================+</b>

Welcome to the DoctOS Help Page; what do you need help with today?

<hyperlink url="/cases">Medical cases</hyperlink>
<hyperlink url="/diagnosing">Diagnosing</hyperlink>
<hyperlink url="/xp">XP and Progression</hyperlink>


`,
        // onVisit
    },
    "404": {
        contents: "\n404 Page Not Found"
    },
    [`http://www.drugle.com/${SpecialPageTypes.Symptoms}`]: {
        contents: "NOT ACTUALLY USED"
    },
    [`http://www.drugle.com/${SpecialPageTypes.Exams}`]: {
        contents: "NOT ACTUALLY USED"
    },
    [`http://www.drugle.com/${SpecialPageTypes.Treatments}`]: {
        contents: "NOT ACTUALLY USED"
    },
    "http://www.drugle.com": {
        contents: `
<drugle imgDisplay="inline" />
\n\n\n<i fontSize="11px" fontFamily="${GAME_FONT_ITALIC}">Covering the entire alphabet of medicines, diseases, and examinations.</i>
`
    },
    "http://www.google.com": {
        contents: "\n\n\nWhat is a google?"
    },
    "about:credits": {
        contents: `
||=======||
||Credits||
||=======||

(placeholder)

Developed by Sam Lynch

Music from:
https://joshuuu.itch.io/short-loopable-background-music

Open Sans font, designed by Steve Matteson
https://fonts.google.com/specimen/Open+Sans

Click SFX from
https://www.fesliyanstudios.com/royalty-free-sound-effects-download/mouse-click-2

Developed using the following open-source packages:
tsthree
dat.gui
ESLint
Firebase
Minisearch
Mousetrap
pixi-tagged-text
pixi.js
stats.js
Terser
TweenJS
ts-node
TypeScript
Webpack
`
    },
    "https://the.diagnosis.game": {
        contents: "\n\n\nSike! Not a real bluescreen :)",
        onVisit: () => {
            ShowBluescreen("Recursion error");
        }
    },
    // "http://slynch.xyz/game": {
    //     contents: "\n\n\nSike! Not a real bluescreen :)",
    //     onVisit: () => {
    //         ShowBluescreen("Recursion error");
    //     }
    // }
};

export const SpecialPages: Record<string, TWebsiteContentID[]> = {
    [SpecialPageTypes.Symptoms]: [`http://www.drugle.com/${SpecialPageTypes.Symptoms}`],
    [SpecialPageTypes.Exams]: [`http://www.drugle.com/${SpecialPageTypes.Exams}`],
    [SpecialPageTypes.Treatments]: [`http://www.drugle.com/${SpecialPageTypes.Treatments}`],
    [SpecialPageTypes.Diagnoses]: [`http://www.drugle.com/${SpecialPageTypes.Diagnoses}`],
};